export const TEAMS = 'TEAMS';
export const TEAM = 'TEAM';
export const DELETE = 'DELETE';
export const SORT = 'SORT';
export const MORE = 'MORE';
export const LOADING = 'LOADING';
export const TOTAL = 'TOTAL';
export const UPDATED = 'UPDATED';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const RESET_FILTER = 'RESET_FILTER';

export default {
  TEAMS,
  TEAM,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  UPDATED,
  CLEAR_ITEMS,
  RESET_FILTER,
};
